import axios from 'axios'

const API = "https://api.vcnews.info"

const getAxios = () => {
    const axiosConfig = {
        baseURL: API,
        timeout: 15000,
    }
    return axios.create(axiosConfig)
}

export const getCurrentNews = () => {
    return getAxios().get("/news/recent")
}

export const getAllNews = () => {
    return getAxios().get("/news")
}

export const getProjects = () => {
    return getAxios().get("/projects")
}